<app-header></app-header>
<main role="main" class="maincnt mainmrg">
  <div class="giveback text-center">
    <div class="givebackbg text-center">
      <div class="sectpad container section d-flex flex-wrap">
          <div class="row d-flex flex-wrap">
        <div class="col-sm-7 subsect pb-0 pl-0 text-left gbipad">
          <div class="d-flex pb-5 gbligimg">
            <div class="col-sm-6 flexauto">
              <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569480522/Static%20images/Giveback/light_u7fvka.svg" alt="Light of Unity logo hot air balloon illustration" title="Light of Unity logo hot air balloon illustration">
            </div>
            <div class="flexauto p-2 givebackbannertxt">
              <h1 class="font-family-calibre-black">Light of Unity</h1>
            </div>
          </div>
          <h2 class="hgg">The Honest Gorilla Giveback</h2>
          <p class="desc webview hggtext">Our mission is to transform energy from a
            commodity to a means for social good. We
            created Honest Gorilla to shed the light of
            unity, while accompanying society to keep
            pushing for the better. </p>
            <p class="desc mobileview mr-5">Our mission is to transform energy from a
              commodity to a means for social good. We
              created Honest Gorilla to shed the light of
              unity, while accompanying society to keep
              pushing for the better. Introducing Light of Unity.</p>
        </div>
        <div class="col-sm-5 subsect pb-0 madshopimage">
          <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569480552/Static%20images/Giveback/bulbs_f6jnb0.svg" alt="Illustration of Light of Unity hot air balloon logo in a landscape view showing three of them flying high" title="Light of Unity Landscape View Illustration" class="bulbsimg webview mt-5" width="600">
          <div class="text-center mb-3 pb-5"><img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569480700/Static%20images/Giveback/givebackmobilebg_tztqzt.svg" alt="Illustration of Light of Unity hot air balloon logo in a landscape view showing three of them flying high" title="Light of Unity Landscape View Illustration" class="mobileview bulbsimgmb mb-4" width="100%"></div>
        </div>
      </div>
      </div>
    </div>
    <div class="givebackworkbg section">
      <div class="container">
      <h2 class="text-center mb-4">How Giveback Works</h2>
      <div class="row col-12 col-sm-12 col-md-12 col-lg-12 m-auto p-0 pb-4">
        <div class="col-sm-4 col-md-4">
          <!-- <div class="col-sm-12  text-center mb-2"><img src="assets/images/lightipad.svg" width="150"></div>
          <div class="col-sm-12 text-center desc mb-2 text-left">You select an energy
            plan you like,
            according to your</div> -->
            <div class="col-sm-12  text-center mb-2 webview"><img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569480347/Static%20images/Giveback/worksimg1_zk2gfa.svg" alt="Illustration of household electronic appliances, including tv, iPad, lamp" title="Common household electronics illustration" width="140"></div>
            <div class="col-sm-12  text-center mb-2 mobileview"><img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569480828/Static%20images/Giveback/energy_qd1irf.svg" alt="Illustration of bunch of lightning bolts contained in a circle" title="Collection of lightning bolts" width="140"></div>
            <div class="col-sm-12 text-center desc bsdtxt mb-2 pl-5 pr-5 text-left webview">
                You select an energy plan you like, according to your unique profile
          </div>
          <div class="col-sm-12 text-center desc bsdtxt mb-4 mobileview">
              Once a year, we will tally up how much energy you and others consumed
            </div>

        </div>
        <div class="col-sm-4 col-md-4 ">
          <div class="col-sm-12 p-0 text-center mb-2"><img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569480375/Static%20images/Giveback/moneytransfer_gztyft.svg" alt="Illustration of coins showing that a stack of coins are separated from the whole, this is to show an illustration of our giveback program." title="Giveback illustration" width="195"></div>
          <div class="col-sm-12 text-center desc bsdtxt mb-2 pl-5 pr-5 webview">Once a year we set aside a portion of our profit to giveback</div>
          <div class="col-sm-12 text-center desc bsdtxt mb-4 mobileview">We recommend to the board how much we’d like to giveback</div>
        </div>
        <div class="col-sm-4 col-md-4">
          <div class="col-sm-12 p-0 text-center mb-2"><img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569480435/Static%20images/Giveback/bulbcloud_pqqjaz.svg" alt="Light of Unity logo hot air balloon illustration in the clouds" title="Light of Unity logo hot air balloon illustration" width="135"></div>
          <div class="col-sm-12 text-center desc bsdtxt mb-2 pl-5 pr-5 webview"> We giveback a certain percentage of our profits to shed the light of unity</div>
          <div class="col-sm-12 text-center desc bsdtxt mb-4 mobileview">We giveback to those whose light could be further illumined</div>
        </div>
      </div>
    </div>
    </div>
    <div class="makedifference section">
      <div class="sectpad container text-left section">
          <div class="row d-flex flex-wrap pb-3">
        <div class="col-sm-6 subsect pb-3">
          <h2>Make a Difference. <br> Light the World.</h2>
          <p class="desc">Since energy is a commodity, we feel we have a duty to help people, in whatever capacity we
            can, to illuminate this world.</p>
          <p class="desc webview">Were it not for your support we would not be able to do what we do. That is why we set aside
            a portion of our profits each year to Light of Unity, so we are all in alignment to help make this world a
            better, brighter place.</p>
        </div>
        <div class="col-sm-6 align-self-center m-auto">
          <hr class="hrbdr"/> 
          <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569480476/Static%20images/Giveback/powerful_jsnqv5.svg" alt="Illumination of light of unity quote So powerful is the light of unity that it can illuminate the whole earth." title="Light of Unity quote" width="100%">
          <hr class="hrbdr"/> 
        </div>
        <div class="col-sm-5 makediffmobtxt subsect mobileview">
        <p class="desc">Were it not for your support we would not be able to do what we do. That is why we set aside
            a portion of our profits each year to Light of Unity, so we are all in alignment to help make this world a
            better, brighter place.</p>
          </div>
        </div>
        </div>
    </div>
    <div class="letsgo section text-center" >
      <div class="sectpad container text-left section">
          <div class="row">
        <div class="col-sm-8 offset-col-sm-2 subsect m-auto text-center pt-5">
          <h2 class="text-center">Join Honest Gorilla and Giveback</h2>
          <p class="desc text-center">Many are choosing to spread the love and shed their light simply by using
            Honest Gorilla as their conduit to a better energy plan. As our community grows, our social impact can
            become even stronger.</p>
          <div class="text-center"><a class="btn letsgobtn mt-3" href="javascript:void(0)" (click)="letsgo()">GET STARTED</a></div>
        </div>
      </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>